import { useLocation } from "react-router-dom";
import { RequireUserPermissions } from "src/components/Permissions/RequireUserPermissions";
import { WithRequiredHasuraRoles } from "src/components/Permissions/WithRequiredHasuraRoles";
import { useFlags } from "src/components/Providers/FeatureFlagProvider";
import * as Url from "src/services/url";
import { FORM_TEMPLATE_TAB_HASH } from "src/services/url/OrgAdmin";
import { HasuraRole } from "src/types/hasuraRole";
import {
  EditMessageTemplateV1,
  EditMessageTemplateV2,
  ListMessageTemplates,
} from ".";

export const AutomaticMessagesTab = () => {
  const params = Url.OrgAdmin.MessageTemplate.useParams();
  const location = useLocation();
  const flags = useFlags(["ai-automatic-messaging-translation"]);

  if (location.hash !== `#${FORM_TEMPLATE_TAB_HASH.AUTOMATIC_MESSAGES}`) {
    return null;
  }

  if (params.mode === "edit") {
    return (
      <RequireUserPermissions permission="automatic_message:update">
        <WithRequiredHasuraRoles
          roles={[HasuraRole.ADMIN, HasuraRole.ORG_ADMIN]}
        >
          {flags["ai-automatic-messaging-translation"].enabled ? (
            <EditMessageTemplateV2 />
          ) : (
            <EditMessageTemplateV1 />
          )}
        </WithRequiredHasuraRoles>
      </RequireUserPermissions>
    );
  }

  return <ListMessageTemplates />;
};
